module.exports = __webpack_public_path__ + "media/images/filter-close-bd7d32d07450264943548fa670fe10b6.png";